import { Component, OnInit, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { StatusPageService } from './maintenance/services/status-page.service';
import { AuthService } from './services/auth.service';
import { InstanaService } from './services/instana.service';
import { UserDataService } from './services/user-data.service';
import { concatMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false,
})
export class AppComponent implements OnInit {
    private instana = inject(InstanaService);
    auth = inject(AuthService);
    private catalog = inject(UserDataService);
    private snackBar = inject(MatSnackBar);
    private translationService = inject(TranslateService);
    private statusPageService = inject(StatusPageService);
    private router = inject(Router);

    title = 'fe-energy-label';
    downtime = true;

    ngOnInit(): void {
        this.statusPageService
            .isDownTime()
            .pipe(
                tap((downtime) => (this.downtime = downtime)),
                concatMap((downtime) => (downtime ? of(undefined) : this.catalog.init())),
            )
            .subscribe({
                error: () => {
                    this.snackBar.open(
                        this.translationService.instant('errors.backend'),
                        this.translationService.instant('errors.ok'),
                    );
                },
            });
        this.router.events.subscribe((val) => {
            if (val instanceof NavigationEnd) {
                this.instana.reportPage(val.urlAfterRedirects);
            }
        });
    }
}
